module.exports = __webpack_public_path__ + "img/组 127.ebed152c.png";